import { Flex, Button, Box } from '@theme-ui/components'
import { Form, Formik, FormikProps } from 'formik'
import React, { ReactNode } from 'react'
import { useQuery } from 'react-query'
import { useParams } from 'react-router'
import { object, string } from 'yup'
import { getRoles } from '../../../api/roles'
import FormikInput from '../../../components/Formik/FormikInput'
import FormikSelect from '../../../components/Formik/FormikSelect'
import { LabeledSelect } from '../../../components/Select/LabeledSelect'

type UserFormProps = {
  isLoading?: boolean
  initialValues: UserFormValues
  onSubmit: (values: UserFormValues) => void
  renderAction?: (formik: FormikProps<UserFormValues>) => ReactNode
}

export type UserFormValues = {
  email: string
  role_ids: number[]
  password?: string
  fname: string
  lname: string
}

export default function UserForm(props: UserFormProps) {
  const { id } = useParams<{ id: string }>()
  const isEdit = !!id
  const { data: roles } = useQuery('/roles', () => {
    return getRoles().then((resp) => resp?.data?.data)
  })

  return (
    <Formik
      initialValues={props.initialValues}
      onSubmit={props.onSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={validationSchema}
    >
      {(formik) => {
        return (
          <Box sx={{ width: ['unset', 9] }}>
            <Form>
              <FormikInput
                row
                name="email"
                label="Email"
                placeholder="johndoe@example.mail"
                disabled={isEdit}
                mb={4}
              />
              {!isEdit && (
                <FormikInput
                  row
                  name="password"
                  label="Password"
                  type="password"
                  mb={4}
                />
              )}
              <LabeledSelect
                row
                name="role_ids"
                label="Role"
                mb={4}
                value={formik.values.role_ids?.[0]}
                onChange={(e) =>
                  formik.setFieldValue('role_ids', [e.target.value])
                }
              >
                <option value=""></option>
                {roles?.map((role) => {
                  return (
                    <option key={role.id} value={role.id}>
                      {role.label}
                    </option>
                  )
                })}
              </LabeledSelect>
              <FormikInput row name="fname" label="First Name" mb={4} />
              <FormikInput row name="lname" label="Last Name" mb={4} />

              <Flex sx={{ justifyContent: 'end', gap: 3 }}>
                <Button type="submit" disabled={props.isLoading}>
                  {props.isLoading ? 'Loading' : 'Simpan'}
                </Button>

                {props.renderAction?.(formik)}
              </Flex>
            </Form>
          </Box>
        )
      }}
    </Formik>
  )
}

const validationSchema = object({
  email: string().email().required(),
})
